import React from "react";
import { CONFIG } from "../config";
import { Reveal } from "../hooks/useReveal";

const DESCRIPTORS = ["Real World Assets", "Digital Settlement", "Global Infrastructure"];

export default function Xylapay() {
  return (
    <section className="w-full py-[80px] lg:py-[160px]">
      <div className="mx-auto max-w-[1280px] px-5 sm:px-8 lg:px-[64px]">
        <Reveal>
          <span className="micro-label">{CONFIG.company}</span>
          <h2 className="mt-5 max-w-[760px] text-[32px] sm:text-[42px] lg:text-[52px] font-medium tracking-[-0.02em] leading-[1.05] text-[#F1F2EF]">
            Infrastructure for real-world value.
          </h2>
          <p className="mt-7 max-w-[600px] text-[16px] sm:text-[18px] leading-[1.65] text-[#A0A5A2]">
            {CONFIG.company} is building financial infrastructure connecting Real
            World Assets with modern blockchain-based settlement.
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-3 border-t hairline">
          {DESCRIPTORS.map((d, i) => (
            <Reveal key={d} delay={0.05 * i}>
              <div className="py-8 sm:pr-8 border-b sm:border-b-0 hairline">
                <div className="text-[11px] tracking-[0.18em] text-[#6D726F] tabular-nums">
                  0{i + 1}
                </div>
                <div className="mt-5 text-[18px] font-medium text-[#F1F2EF]">{d}</div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
